// /* eslint-disable no-unused-vars */
//   import React, { useEffect, useState } from "react";
//   import { useDispatch, useSelector } from "react-redux";
//   import { useNavigate } from "react-router-dom";
//   import { fetchLoanReports, deleteLoan } from "../redux/slices/loanReportSlice";
//   import { ToastContainer, toast } from "react-toastify";
//   import "react-toastify/dist/ReactToastify.css";
//   import "../css/LoanReport.css";
//   import axios from 'axios';

//   const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];

//   const API_URL = 'https://payyug.in/api/'; // replace with your API base

//   const LoanReport = () => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     const { loans, loading, error } = useSelector((state) => state.loanReport);

//     const [filterData, setFilterData] = useState({
//       fromDate: "",
//       toDate: "",
//       loanAccountNumber: "",
//       userId: "",
//       userName: "",
//       loanStatus: "",
//     });

//     const [filteredLoans, setFilteredLoans] = useState([]);
//       const [showConfirmDialog, setShowConfirmDialog] = useState(false);

//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage, setItemsPerPage] = useState(10);

//     useEffect(() => {
//       dispatch(fetchLoanReports());
//     }, [dispatch]);

//     useEffect(() => {
//       setFilteredLoans(loans);
//       setCurrentPage(1);
//     }, [loans]);

//     useEffect(() => {
//       if (error) {
//         toast.error(`Error: ${error}`);
//       }
//     }, [error]);

//     const handleChange = (e) => {
//       setFilterData({ ...filterData, [e.target.name]: e.target.value });
//     };

//     const handleSubmit = (e) => {
//       e.preventDefault();
//       const filtered = loans.filter((loan) => {
//         const {
//           fromDate,
//           toDate,
//           loanAccountNumber,
//           userId,
//           userName,
//           loanStatus,
//         } = filterData;
//         const appliedDate = new Date(loan.appliedDate);

//         return (
//           (!fromDate || appliedDate >= new Date(fromDate)) &&
//           (!toDate || appliedDate <= new Date(toDate)) &&
//           (!loanAccountNumber ||
//             loan.loanAccountNumber
//               ?.toLowerCase()
//               .includes(loanAccountNumber.toLowerCase())) &&
//           (!userId || loan.userId?.toString() === userId) &&
//           (!userName ||
//             loan.userName?.toLowerCase().includes(userName.toLowerCase())) &&
//           (!loanStatus || loan.status?.toLowerCase() === loanStatus.toLowerCase())
//         );
//       });

//       setFilteredLoans(filtered);
//       setCurrentPage(1);
//     };

//   const handleApproveLoan = async (loan) => {
//     console.log('➡️ Approve Loan button clicked');
//     console.log('Loan ID:', loan.id);
//     console.log('Current Loan Status:', loan.status);

//     if (loan.status === 'Approved' || loan.status === 'disbursed') {
//       console.info(`⚠️ Loan is already ${loan.status}, skipping approval.`);
//       toast.info(`Loan is already ${loan.status}`);
//       return;
//     }

//     try {
//       console.log('🔧 Sending approve loan API request...');
//       const response = await axios.post(
//         `${API_URL}approveLoan-personal/${loan.id}/approve`,
//         { approvalRemark: 'Verified documents' }
//       );

//       console.log('✅ API Response:', response.data);
//       toast.success(response.data.message);

//       dispatch(fetchLoanReports());

//       // Optionally navigate to disbursement page after approval
//     } catch (error) {
//       console.error('🚨 Loan Approval Error:', error);
//       toast.error(error.response?.data?.message || 'Failed to approve loan');
//     }
//   };

//     const handleItemsPerPageChange = (e) => {
//       setItemsPerPage(Number(e.target.value));
//       setCurrentPage(1);
//     };

//     const formatDate = (dateStr) => {
//       if (!dateStr) return "N/A";
//       const date = new Date(dateStr);
//       return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
//         2,
//         "0"
//       )}-${String(date.getDate()).padStart(2, "0")} ${String(
//         date.getHours()
//       ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
//     };

//     // const handleDelete = (loanId) => {
//     //   dispatch(deleteLoan(loanId))
//     //     .unwrap()
//     //     .then(() => toast.success("Loan deleted successfully!"))
//     //     .catch((err) => toast.error(`Delete failed: ${err}`));
//     // };

//     const totalPages = Math.ceil(filteredLoans.length / itemsPerPage);
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const currentLoans = filteredLoans.slice(
//       startIndex,
//       startIndex + itemsPerPage
//     );

//     return (
//       <div className="LoanReport-container">
//         {/* Filter Section */}
//         <section className="LoanReport-filterSection">
//           <h2 className="LoanReport-title">Loan Report Filter</h2>
//           <p className="LoanReport-subtitle">
//             Use filter to see more precise report
//           </p>
//           <form className="LoanReport-form" onSubmit={handleSubmit}>
//             <div className="LoanReport-grid">
//               <div className="LoanReport-formGroup">
//                 <label>From Date</label>
//                 <input type="date" name="fromDate" onChange={handleChange} />
//               </div>
//               <div className="LoanReport-formGroup">
//                 <label>To Date</label>
//                 <input type="date" name="toDate" onChange={handleChange} />
//               </div>
//               <div className="LoanReport-formGroup">
//                 <label>Loan Account Number</label>
//                 <input
//                   type="text"
//                   name="loanAccountNumber"
//                   placeholder="Loan account number"
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="LoanReport-formGroup">
//                 <label>Applicant User ID</label>
//                 <input
//                   type="text"
//                   name="userId"
//                   placeholder="Applicant user id"
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="LoanReport-formGroup">
//                 <label>Applicant User Name</label>
//                 <input
//                   type="text"
//                   name="userName"
//                   placeholder="Applicant user name"
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="LoanReport-formGroup">
//                 <label>Choose Loan Status</label>
//                 <select name="loanStatus" onChange={handleChange}>
//                   <option value="">Select loan status</option>
//                   <option value="Pending">Pending</option>
//                   <option value="Approved">Approved</option>
//                   <option value="Rejected">Rejected</option>
//                   <option value="Closed">Closed</option>
//                 </select>
//               </div>
//             </div>
//             <button type="submit" className="LoanReport-submitBtn">
//               Submit
//             </button>
//           </form>
//         </section>

//         {/* Loan Details Section */}
//         <section className="LoanReport-detailsSection">
//           <div className="LoanReport-tableHeader">
//             <div>
//               <label>Show </label>
//               <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
//                 {ITEMS_PER_PAGE_OPTIONS.map((count) => (
//                   <option key={count} value={count}>
//                     {count}
//                   </option>
//                 ))}
//               </select>
//               <span> entries</span>
//             </div>
//             <input
//               type="text"
//               placeholder="Search..."
//               className="LoanReport-searchInput"
//             />
//           </div>

//           <div className="LoanReport-tableContainer">
//             <table className="LoanReport-table">
//               <thead>
//                 <tr>
//                   <th>SN</th>
//                   <th>Account Number</th>
//                   <th>Loan ID</th>
//                   <th>Borrower Name</th>
//                   <th>Loan Amount</th>
//                   <th>Interest Amount</th>
//                   <th>Loan Tenure</th>
//                   <th>Loan Frequency</th>
//                   <th>Applied Date</th>
//                   <th>Approval Date</th>
//                   <th>Disbursal Date</th>
//                   <th>Loan Status</th>
//                   <th>EMI Amount</th>
//                   <th>Total Payable</th>
//                   {/* <th>Loan Purpose</th> */}
//                   <th>Loan Type</th>
//                   {/* <th>Landmark</th> */}
//                   <th>View EMI</th>
//                   <th>Loan Card</th>
//                   {/* <th>KYC Status</th>
//                   <th>Approval / Update / Delete</th> */}
//                   <th>Loan Status</th>
//                   <th>Approved Action</th>
//                   <th>Disbursement Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan="22">Loading...</td>
//                   </tr>
//                 ) : error ? (
//                   <tr>
//                     <td colSpan="22">Error: {error}</td>
//                   </tr>
//                 ) : currentLoans.length === 0 ? (
//                   <tr>
//                     <td colSpan="22">No data available</td>
//                   </tr>
//                 ) : (
//                   currentLoans.map((loan, index) => (
//                     <tr key={loan.id}>
//                       <td>{startIndex + index + 1}</td>
//                       <td>{loan.loanAccountNumber || "N/A"}</td>
//                       <td>{loan.id || "N/A"}</td>
//                       <td>{loan.userName || "N/A"}</td>
//                       <td>{loan.loanAmount || "N/A"}</td>
//                       <td>{loan.loanInterest || "N/A"}</td>
//                       <td>{loan.loanTenure || "N/A"}</td>
//                       <td>{loan.loanRecoveryFrequency || "N/A"}</td>
//                       <td>{formatDate(loan.loanAppliedDate)}</td>
//                       <td>{formatDate(loan.firstEmiDate)}</td>
//                       <td>{formatDate(loan.disbursalDate)}</td>
//                       <td>{loan.status || "N/A"}</td>
//                       <td>{loan.loanEmiAmount || "N/A"}</td>
//                       <td>{loan.loanPayable || "N/A"}</td>
//                       {/* <td>{loan.loanPurpose || "N/A"}</td> */}
//                       <td>{loan.loanType || "N/A"}</td>
//                       {/* <td>{loan.collectionLandmark || "N/A"}</td> */}
//                       <td>
//                         <button
//                           onClick={() => navigate(`/ViewEmiLoanData/${loan.id}`)}
//                         >
//                           View EMI
//                         </button>
//                       </td>
//                       <td>
//                         <button
//                         onClick={() => navigate(`/LoanCardPage/${loan.id}`)}>Loan Card</button>
//                       </td>
//                       {/* <td>
//                         <span
//                           style={{
//                             padding: "4px 8px",
//                             borderRadius: "6px",
//                             fontWeight: "bold",
//                             backgroundColor:
//                               loan.kycStatus === "Approved"
//                                 ? "#c8e6c9"
//                                 : loan.kycStatus === "Rejected"
//                                 ? "#ffcdd2"
//                                 : loan.kycStatus === "Pending"
//                                 ? "#ffe082"
//                                 : "#e0e0e0",
//                             color:
//                               loan.kycStatus === "Approved"
//                                 ? "#2e7d32"
//                                 : loan.kycStatus === "Rejected"
//                                 ? "#c62828"
//                                 : loan.kycStatus === "Pending"
//                                 ? "#ef6c00"
//                                 : "#616161",
//                           }}
//                         >
//                           {loan.kycStatus || "N/A"}
//                         </span>
//                       </td> */}
//                       {/* <td>
//                         <button
//                           onClick={() => navigate(`/LoanKycApproval/${loan.id}`)}
//                         >
//                           Approval
//                         </button>
//                         <button
//                           onClick={() => navigate(`/UpdateLoan/${loan.id}`)}
//                           style={{
//                             marginLeft: "6px",
//                             backgroundColor: "#1976d2",
//                           }}
//                         >
//                           Update
//                         </button>
//                         <button
//                           onClick={() => handleDelete(loan.id)}
//                           style={{
//                             marginLeft: "6px",
//                             background: "red",
//                             color: "#fff",
//                           }}
//                         >
//                           Delete
//                         </button>
//                       </td> */}
//                       <td>{loan.status || "N/A"}</td>

//                       <td>

//                           {/* <button
//                             onClick={() => handleApproveLoan(loan.id)}

//                             style={{
//                               marginLeft: "6px",
//                               background: "#1f8b94ff",
//                               color: "#fff",
//                               padding: "5px 10px",
//                               border: "none",
//                               borderRadius: "4px",
//                             }}
//                           >
//                             Approve Loan
//                           </button> */}

//                             {loan.status === "PENDING" && (
//                                                   <button onClick={() => handleApproveLoan(loan)}>Approve Loan</button>

//                         )}

//                       </td>
//                       <td>
//                         {loan.status === "Approved" && (
//                           <button
//                             onClick={() =>
//                               navigate(`/LoanDisbursement/${loan.id}`, {
//                                 state: { selectedLoan: loan },
//                               })
//                             }
//                             style={{
//                               marginLeft: "6px",
//                               background: "#1f8b94ff",
//                               color: "#fff",
//                               padding: "5px 10px",
//                               border: "none",
//                               borderRadius: "4px",
//                             }}
//                           >
//                             Disburse Loan
//                           </button>
//                         )}
//                       </td>

//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination Controls */}
//           {totalPages > 1 && (
//             <div className="LoanReport-pagination">
//               <button
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage((prev) => prev - 1)}
//               >
//                 Previous
//               </button>
//               <span>
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage((prev) => prev + 1)}
//               >
//                 Next
//               </button>
//             </div>
//           )}
//         </section>

//         <ToastContainer position="top-right" autoClose={3000} />

//       </div>
//     );
//   };

//   export default LoanReport;

/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchLoanReports, deleteLoan } from "../redux/slices/loanReportSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/LoanReport.css";
import axios from "axios";
import { Trash } from "lucide-react";
import { getBranches } from "../redux/slices/CreateCustomerSlice";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];

const API_URL = "https://payyug.in/api/";

const LoanReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loans, loading, error } = useSelector((state) => state.loanReport);
  const { branches } = useSelector((state) => state.customer);
  const { list: employee } = useSelector((state) => state.employeeReport);

  const [filterData, setFilterData] = useState({
    fromDate: "",
    toDate: "",
    loanAccountNumber: "",
    userId: "",
    branchId: "",
    userName: "",
    loanStatus: "",
    loanType: "",
  });

  const [filteredLoans, setFilteredLoans] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");

  const superAdminId = Number(localStorage.getItem("adminuserId"));

  useEffect(() => {
    if (!superAdminId) return;
    dispatch(getBranches(superAdminId));
  }, [dispatch, superAdminId]);

  useEffect(() => {
    dispatch(
      fetchLoanReports(),
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchEmployeeReport({ page: 1, pageSize: 100 }));
  }, [dispatch]);

  useEffect(() => {
    setFilteredLoans(loans);
    setCurrentPage(1);
  }, [loans]);

  useEffect(() => {
    if (error) {
      toast.error(`Error: ${error}`);
    }
  }, [error]);

  const handleChange = (e) => {
    setFilterData({ ...filterData, [e.target.name]: e.target.value });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const filtered = loans.filter((loan) => {
  //     const {
  //       fromDate,
  //       toDate,
  //       loanAccountNumber,
  //       userId,
  //       userName,
  //       loanStatus,
  //     } = filterData;
  //     const appliedDate = new Date(loan.loanAppliedDate);

  //     return (
  //       (!selectedBranch || loan.branchId === selectedBranch) &&
  //       (!fromDate || appliedDate >= new Date(fromDate)) &&
  //       (!toDate || appliedDate <= new Date(toDate)) &&
  //       (!loanAccountNumber ||
  //         loan.loanAccountNumber
  //           ?.toLowerCase()
  //           .includes(loanAccountNumber.toLowerCase())) &&
  //       (!userId || loan.userId?.toString() === userId) &&
  //       (!userName ||
  //         loan.userName?.toLowerCase().includes(userName.toLowerCase())) &&
  //       (!loanStatus || loan.status?.toLowerCase() === loanStatus.toLowerCase())
  //     );
  //   });

  //   setFilteredLoans(filtered);
  //   setCurrentPage(1);
  // };

  const handleSubmit = (e) => {
  if (e) e.preventDefault(); // Handle cases where e might be null
  
  const filtered = loans.filter((loan) => {
    const { fromDate, toDate, loanAccountNumber, userName, loanStatus, loanType } = filterData;
    const appliedDate = new Date(loan.loanAppliedDate);

    return (

      // (!selectedBranch || loan.branchId === selectedBranch.id) &&
      
      (!selectedEmployee || loan.userId === selectedEmployee.id) && 
      
      (!fromDate || appliedDate >= new Date(fromDate)) &&
      (!toDate || appliedDate <= new Date(toDate)) &&
      (!loanAccountNumber || loan.loanAccountNumber?.toLowerCase().includes(loanAccountNumber.toLowerCase())) &&
      (!userName || loan.userName?.toLowerCase().includes(userName.toLowerCase())) &&
      (!loanStatus || loan.status?.toLowerCase() === loanStatus.toLowerCase()) &&
      (!loanType || loan.loanType?.toLowerCase() === loanType.toLowerCase())
    );
  });

  setFilteredLoans(filtered);
  setCurrentPage(1);
};

  // auto filter by selecting branch
  useEffect(() => {
    handleSubmit({ preventDefault: () => {} });
  }, [selectedEmployee]);

  // auto filter by selecting branch or employee
// useEffect(() => {
//   handleSubmit();
// }, [selectedEmployee]); 

  // delete loan
  const handleDelete = (loanId, loanAccountNumber) => {
    const confirm = window.confirm(
      `Are you sure to delete this loan= ${loanAccountNumber}`,
    );
    if (confirm) {
      dispatch(deleteLoan(loanId));
    }
  };

  const handleApproveLoan = async (loan) => {
    console.log("➡️ Approve Loan button clicked");
    console.log("Loan ID:", loan.id);
    console.log("Current Loan Status:", loan.status);

    if (loan.status === "Approved" || loan.status === "disbursed") {
      console.info(`⚠️ Loan is already ${loan.status}, skipping approval.`);
      toast.info(`Loan is already ${loan.status}`);
      return;
    }

    try {
      console.log("🔧 Sending approve loan API request...");
      const response = await axios.post(
        `${API_URL}approveLoan-personal/${loan.id}/approve`,
        { approvalRemark: "Verified documents" },
      );

      console.log("✅ API Response:", response.data);
      toast.success(response.data.message);

      dispatch(fetchLoanReports());
    } catch (error) {
      console.error("🚨 Loan Approval Error:", error);
      toast.error(error.response?.data?.message || "Failed to approve loan");
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0",
    )}-${String(date.getDate()).padStart(2, "0")} ${String(
      date.getHours(),
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };

  const totalPages = Math.ceil(filteredLoans.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentLoans = filteredLoans.slice(
    startIndex,
    startIndex + itemsPerPage,
  );

  return (
    <div className="LoanReport-container">
      {/* Filter Section */}
      <section className="LoanReport-filterSection">
        <h2 className="LoanReport-title">Loan Report Filter</h2>
        <p className="LoanReport-subtitle">
          Use filter to see more precise report
        </p>
        <form className="LoanReport-form" onSubmit={handleSubmit}>
          <div className="LoanReport-grid">
            {/* <div className="LoanReport-formGroup">
              <label>Select Branch</label>
              <select
                value={selectedBranch || ""}
                onChange={(e) => {
                  setSelectedBranch(Number(e.target.value) || "");
                  setCurrentPage(1);
                }}
              >
                <option value="">All Branches</option>
                {branches.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div> */}
            <div className="LoanReport-formGroup">
              <label>Select Branch</label>
              <select
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const val = e.target.value;
                  const branchObj = branches.find(
                    (br) => br.id === Number(val),
                  );
                  setSelectedBranch(branchObj || ""); // Agar "All" select kiya toh null/empty
                  setSelectedEmployee(""); // Branch change hone par employee reset karein
                  setCurrentPage(1);
                }}
              >
                <option value="">All Branches</option>
                {branches.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="LoanReport-formGroup">
              <label>Select Employee</label>
              <select
                value={selectedEmployee?.id || ""}
                onChange={(e) => {
                  const val = e.target.value;
                  const empObj = employee.find((em) => em.id === Number(val));
                  setSelectedEmployee(empObj || ""); // If "All" is selected, empObj is undefined, setting it to ""
                  setCurrentPage(1);
                }}
              >
                <option value="">All Employees</option>
                {employee
                  .filter(
                    (emp) =>
                      !selectedBranch || emp.branchId === selectedBranch.id,
                  )
                  .map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.fullName}
                    </option>
                  ))}
              </select>
            </div>
            <div className="LoanReport-formGroup">
              <label>From Date</label>
              <input type="date" name="fromDate" onChange={handleChange} />
            </div>
            <div className="LoanReport-formGroup">
              <label>To Date</label>
              <input type="date" name="toDate" onChange={handleChange} />
            </div>
            <div className="LoanReport-formGroup">
              <label>Loan Account Number</label>
              <input
                type="text"
                name="loanAccountNumber"
                placeholder="Loan account number"
                onChange={handleChange}
              />
            </div>
            {/* <div className="LoanReport-formGroup">
              <label>Applicant User ID</label>
              <input
                type="text"
                name="userId"
                placeholder="Applicant user id"
                onChange={handleChange}
              />
            </div> */}
            <div className="LoanReport-formGroup">
              <label>Applicant User Name</label>
              <input
                type="text"
                name="userName"
                placeholder="Applicant user name"
                onChange={handleChange}
              />
            </div>
            <div className="LoanReport-formGroup">
              <label>Choose Loan Status</label>
              <select name="loanStatus" onChange={handleChange}>
                <option value="">Select loan status</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
                <option value="Closed">Closed</option>
              </select>
            </div>
            <div className="LoanReport-formGroup">
              <label>Loan Type</label>
              <select name="loanType" onChange={handleChange}>
                <option value="">All Loan Types</option>
                <option value="Fixed">Fixed</option>
                <option value="Personal">Personal</option>
              </select>
            </div>
          </div>
          <button type="submit" className="LoanReport-submitBtn">
            Submit
          </button>
        </form>
      </section>

      {/* Loan Details Section */}
      <section className="LoanReport-detailsSection">
        <div className="LoanReport-tableHeader">
          <div>
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
          <input
            type="text"
            placeholder="Search..."
            className="LoanReport-searchInput"
            onChange={(e) => {
              const value = e.target.value.toLowerCase();

              const filtered = loans.filter(
                (loan) =>
                  loan.userName?.toLowerCase().includes(value) ||
                  loan.loanAccountNumber?.toLowerCase().includes(value),
              );

              setFilteredLoans(filtered);
              setCurrentPage(1);
            }}
          />
        </div>

        <div className="LoanReport-tableContainer">
          <table className="LoanReport-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Loan ID</th>
                <th>Borrower Name</th>
                <th>Loan Amount</th>
                <th>Interest Amount</th>
                <th>Loan Tenure</th>
                <th>Loan Frequency</th>
                <th>Applied Date</th>
                <th>Approval Date</th>
                <th>Disbursal Date</th>
                <th>Loan Status</th>
                <th>EMI Amount</th>
                <th>Total Payable</th>
                <th>Loan Type</th>
                <th>View EMI</th>
                <th>Loan Card</th>
                <th>Loan Status</th>
                <th>Approved</th>
                <th>Disbursed</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="22">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="22">Error: {error}</td>
                </tr>
              ) : currentLoans.length === 0 ? (
                <tr>
                  <td colSpan="22">No data available</td>
                </tr>
              ) : (
                currentLoans.map((loan, index) => {
                  const status = loan.status?.toLowerCase();
                  return (
                    <tr
                      key={loan.id}
                      style={{
                        backgroundColor:
                          loan.status?.toLowerCase() === "closed"
                            ? "#f8d7da"
                            : "transparent",
                      }}
                    >
                      <td>{startIndex + index + 1}</td>
                      <td>{loan.loanAccountNumber || "N/A"}</td>
                      <td>{loan.userName || "N/A"}</td>
                      <td>{loan.loanAmount || "N/A"}</td>
                      <td>{loan.loanInterest || "N/A"}</td>
                      <td>{loan.loanTenure || "N/A"}</td>
                      <td>{loan.loanRecoveryFrequency || "N/A"}</td>
                      <td>
                        {new Date(loan.loanAppliedDate).toLocaleDateString(
                          "en-GB",
                        ) || "N/A"}
                      </td>
                      <td>
                        {new Date(loan.firstEmiDate).toLocaleDateString(
                          "en-GB",
                        ) || "N/A"}
                      </td>
                      <td>
                        {new Date(loan.disbursalDate).toLocaleDateString(
                          "en-GB",
                        ) || "N/A"}
                      </td>
                      <td>{loan.status || "N/A"}</td>
                      <td>{loan.loanEmiAmount || "N/A"}</td>
                      <td>{loan.loanPayable || "N/A"}</td>
                      <td>{loan.loanType || "N/A"}</td>
                      <td>
                        {status === "disbursed" && (
                          <button
                            onClick={() =>
                              navigate(`/ViewEmiLoanData/${loan.id}`, {
                                state: loan,
                              })
                            }
                          >
                            View EMI
                          </button>
                        )}
                      </td>
                      <td>
                        {status === "disbursed" && (
                          <button
                            onClick={() => navigate(`/LoanCardPage/${loan.id}`)}
                          >
                            Loan Card
                          </button>
                        )}
                      </td>
                      <td>{loan.status || "N/A"}</td>

                      <td>
                        {status === "approved" ||
                        status === "disbursed" ||
                        status === "active" ? (
                          <span style={{ color: "green", fontWeight: "700" }}>
                            ✔
                          </span>
                        ) : (
                          <span style={{ color: "red", fontWeight: "700" }}>
                            X
                          </span>
                        )}
                      </td>

                      <td>
                        {status === "disbursed" || status === "active" ? (
                          <span style={{ color: "green", fontWeight: "700" }}>
                            ✔
                          </span>
                        ) : (
                          <span style={{ color: "red", fontWeight: "700" }}>
                            X
                          </span>
                        )}
                      </td>

                      {/* <td>
                      {loan.status === "PENDING" && (
                        <button
                          onClick={() => {
                            const confirmApprove = window.confirm(
                              "Do you want to approve this loan?"
                            );
                            if (confirmApprove) handleApproveLoan(loan);
                          }}
                        >
                          Approve Loan
                        </button>
                      )}
                      {(loan.status === "Approved" || loan.status === "disbursed") && (
                        <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
                      )}
                    </td>

                    <td>
                      {loan.status === "Approved" && (
                        <button
                          onClick={() =>
                            navigate(`/LoanDisbursement/${loan.id}`, {
                              state: { selectedLoan: loan },
                            })
                          }
                          style={{
                            marginLeft: "6px",
                            background: "#1f8b94ff",
                            color: "#fff",
                            padding: "5px 10px",
                            border: "none",
                            borderRadius: "4px",
                          }}
                        >
                          Disburse Loan
                        </button>
                      )}
                      {loan.status === "disbursed" && (
                        <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
                      )}
                    </td> */}
                      <td>
                        <button
                          className="loan-delete-btn"
                          onClick={() =>
                            handleDelete(loan.id, loan.loanAccountNumber)
                          }
                        >
                          <Trash />
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="LoanReport-pagination">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => prev + 1)}
            >
              Next
            </button>
          </div>
        )}
      </section>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default LoanReport;
